<template>
    <form @submit.prevent="onClickSubmitLogin">
        <div class="form-login">
            <div class="form-login__input_large">
                <input
                    v-model="code"
                    placeholder="Код"
                />
            </div>
            <div v-if="counter === 0" class="form-login__btn-repeat-container">
                <span @click="onClickCodeRepeat">Повторно отправить код</span>
            </div>
            <div class="form-login__btn-timer-container" v-if="counter > 0">
                <span >Повторная отправка через 00:{{printCounter()}}</span>
            </div>
            <div class="form-login__btn-container">
                <button
                    type="submit" 
                    class="form-login__btn_login"
                >
                    Войти
                </button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: "FormLoginSms",
    /**
     * @property {string} phone - телефон
     * @property {string} code - код
     * @property {number} counter - счетчик для таймера
     */
    data: () => ({
        code: '',
        counter: 60
    }),
    computed: {
        /**
         * данные формы
         * @returns {object}
         */
        formData() {
            let data = {
                code: this.code
            };
            return data;
        }
    },
    mounted() {
        this.countDown();
    },
    methods: {
        /**
         * событие клика по кнопке
         */
        onClickSubmitLogin() {
            this.$emit('submitFormLogin', this.formData);
        },
        /**
         * событие клика по кнопке
         */
        onClickCodeRepeat() {
            this.$emit('codeRepeat');
            this.counter = 60;
            this.countDown();
        },
        /**
         * Таймер
         * @returns {number}
         */
        countDown() {
            if (this.counter) {
                return setTimeout(() => {
                    --this.counter
                    this.countDown()
                }, 1000)
            }
            // this.$router.push({ path: '/2'})
        },
        /**
         * отображение числа таймера
         * @returns {string|number}
         */
        printCounter() {
            if(this.counter < 10){
                return '0' + this.counter;
            }else{
                return this.counter;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    button:focus {
        outline: 0;
    }
    .form-login__input_large {
        position: relative;
    }
    %form-login-ui-content {
        font-size: 16px;
        height: 60px;
        border-radius: 60px;
        font-weight: bold;
        font-family: 'Segoe UI SemiBold';
        transition: all 250ms;
    }
    .form-login .form-login__input_large input {
        @extend %form-login-ui-content;
        width: 100%;
        background: #fff;
        border: 1px solid #fff;
        outline: 0;
        padding: 0 40px;
        margin-bottom: 10px;
        box-sizing: border-box;
    }
    .form-login__btn-container {
        text-align: center;
        margin-top: 20px;
    }
    .form-login__btn_login {
        @extend %form-login-ui-content;
        background: #2686e6;
        color: #fff;
        text-align: center;
        width: 60%;
        cursor: pointer;
        border: 0;
    }
    .form-login__btn_login:hover {
        background: #1f79d2;
    }
    .form-login__btn-repeat-container{
        text-align: center;
    }
    .form-login__btn-repeat-container span{
        cursor: pointer;
        color: #2686e6;
    }
    .form-login__btn-repeat-container span:hover{
        text-decoration: underline;
    }
    .form-login__btn-timer-container{
        text-align: center;
    }
</style>